import Carousel from '@/common/Carousel/Carousel';
import TrackWrapper from '~/components/common/TrackWrapper';
import { RecommendedVehicle } from '~/contracts/vdp';
import useCarouselSettings from '~/hooks/home/useCarouselSettings';
import { getNativeVdpPayload } from '~/native/home/utils';
import V2HomeTile from './V2HomeTile';

type OwnProps = {
  vehicles: RecommendedVehicle[];
  title: string;
  dataQa: string;
};

export default function RecCarousel({ title, vehicles, dataQa }: OwnProps) {
  const { values, carouselRef } = useCarouselSettings({
    heading: title,
    maxLength: vehicles.length
  });

  const viewEvent = {
    eventName: 'Viewed - Home feed section',
    customAttributes: {
      description: title,
      isCarousel: true,
      content: vehicles.map(vehicle => vehicle.vehicleId)
    }
  };

  return (
    <TrackWrapper event={viewEvent}>
      <Carousel {...values} ref={carouselRef} dataQa={dataQa}>
        {vehicles.map(vehicle => {
          const { vehicleId } = vehicle;

          return (
            <a
              href={`/vehicle/${vehicleId}`}
              key={vehicleId}
              data-analytics-id="Home feed card"
              data-analytics-attributes={JSON.stringify({
                description: `${title} tile`,
                vehicleId
              })}
              data-native-payload={getNativeVdpPayload(vehicleId)}
            >
              <V2HomeTile {...vehicle} sectionTitle={title} />
            </a>
          );
        })}
      </Carousel>
    </TrackWrapper>
  );
}
